import * as React from 'react';

const aboutImage = require('../assets/img/about.png')
const About = () => {
  return (
    <main>
      <section className="px-8 py-16 mx-auto max-w-7xl">
        <div className="grid grid-cols-12 gap-6">
          <div className="col-span-12 prose-lg text-gray-300 lg:col-span-7">
            <h1
              className="mt-2 mb-8 font-extrabold leading-8 tracking-tight text-gray-100"
            >
              What is Horror Lex®?
            </h1>
            <p>
              Horror Lex launched in November 2021 as the first and only academic research site
              dedicated to serious writing about horror and horror-adjacent films. If it’s about
              ghosts, demons, zombies, vampires, black-gloved killers, exploding heads, deadly
              viruses, psycho grandmas, creepy kids, giant squids, or even killer nuns, it’s on
              Horror Lex.
            </p>
            <p>
              The Horror Lex database currently indexes over <span className='text-bold'>13,000</span> writings – published books,
              articles, and online writings, many from university publishers and peer-reviewed
              journals – from over a thousand different sources. A significant number of these
              works is available for free online, but finding them can be frustrating and
              time-consuming.
            </p>
          </div>
          <div className="col-span-5">
            <figure>
              <div className="relative pb-7/12 lg:pb-0">
                <img
                  src={aboutImage}
                  alt=""
                  width="1184"
                  height="1376"
                  className="absolute inset-0 object-cover object-center w-full h-full rounded-lg lg:static lg:h-auto"
                />
              </div>
            </figure>
          </div>
        </div>
        <div>
          <div className="prose prose-lg text-gray-300">
            <h3 className="text-white">How do I use Horror Lex®?</h3>
            <p>Use a Quick Search to look for anything, fast.</p>
            <p>
              Use Advanced Search to dive in deeper. Search by year, title, author,
              ISSN/ISBN, keyword, and other criteria.
            </p>
            <p>
              Use the Browse function to poke around. Horror Lex uses hundreds of specialized,
              horror-focused tags that you won’t find anywhere else, like “aquatic horror,”
              “orientalism,” and “Final Girl”, plus actors’ and directors’ names, subgenres,
              countries of origin, and so much more. You can browse them all. Or, do you have a
              favorite film? Browse the 6,000 horror and horror-adjacent films that are covered by
              the works indexed here, from A to Z. Sure, there’s been plenty of writing about The
              Exorcist (1973), but maybe you’re more into The Alligator People (1959) or Goremet,
              Zombie Chef from Hell (1986) – they’re all here.
            </p>
            <p>
              If you’re looking for guidance and want to see what Professor Lex has selected as the
              best of the best, click the “Horror Lex Recommended” box in the Advanced Search.
            </p>
            <h3 className="text-white">Where are the actual books, articles, etc?</h3>
            <p>
              Horror Lex does not house or own the copyright to any of the authors’ works indexed
              here, and so you cannot download them directly from the site. However, the entire
              purpose of Horror Lex is to direct you to a free, open access source whenever
              possible.
            </p>
            <p>
              When no free, open access source is available, Horror Lex directs you to the next best
              thing: Google Books, membership databases like JSTOR and Muse, publishers’ websites,
              and anywhere else you can find the item you’re looking for.
            </p>
            <h3 className="text-white">
              I’ve got a great horror blog/zine/self-published book. Can you add it to Horror Lex®?
            </h3>
            <p>
              Sure…maybe! One of the benefits of using Horror Lex for your research is that, unlike
              just throwing search terms into your browser and wading through a lifetime’s worth of
              random blog posts, the collection of writings here is curated by hand. Every writing
              has been published by a reputable third party or an academic source, or, even if
              self-published, is of similar, thoughtful, well-researched quality. Horror Lex does
              not index industry or entertainment pieces (such as those in Rue Morgue and
              Cinefastique, even though there is great writing in those magazines – check them out
              on their own websites). In addition, Horror Lex does not index mere film reviews,
              unless from an industry-recognized literary or academic source (like Sight & Sound).
            </p>
            <p>
              In the end, however, one wolf’s trash is another wolf’s treasure, and Professor Lex
              errs on the side of including rather than excluding works.
            </p>
            <p>
              If you know of a writing about horror or horror-adjacent film that isn’t on the site,
              whether written by you or someone else, please Contact Professor Lex.
            </p>
            <h3 className="text-white">What else can Horror Lex® do?</h3>
            <p>
              Professor Lex is eager to expand Horror Lex to provide even more features and content.
              Look for these new additions soon:
            </p>
            <ul>
              <li>Search academic theses</li>
              <li>Search conference materials</li>
              <li>Limit your search to peer-reviewed journals</li>
              <li>Search audiobooks</li>
              <li>Horror Lex Top Authors</li>
            </ul>
            <p>Have a suggestion to make Horror Lex even better?</p>
            <a href="/contact">Contact Professor Lex</a>
            <h3 className="text-white">Who is Professor Lex?</h3>
            <p>
              Professor Lupe Lex, PhD, S.L.W., is a tenured professor of English and Film Studies at
              an undisclosed university, and also a proud werewolf. Professor Lex is pleased to be
              your host of this site and is available to take your questions here.
            </p>
            <h3 className="text-white">Rights &amp; Credits</h3>
            <p>Horror Lex® is owned by Horror Lex LLC. All rights reserved.</p>
            <p>
                Research assistance by Andrew Sanger.
            </p>
            <p>
                Illustrations copyright David Procter <a href="http://www.david-procter.co.uk" target="_blank" rel="noopener">(www.david-procter.co.uk)</a>. All other copyright Horror Lex LLC.
            </p>
          </div>
        </div>
      </section>
    </main>
  )
}

export default About;
